export const dashboardPagesMenu = {
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/',
		icon: 'Dashboard',
		subMenu: null,
	},
};

export const demoPagesMenu = {
	auth: {
		id: 'auth',
		text: 'Auth Pages',
		icon: 'Extension',
	},
	login: {
		id: 'login',
		text: 'Login',
		path: '/login',
		icon: 'Login',
	},
	signUp: {
		id: 'signUp',
		text: 'Sign Up',
		path: '/sign-up',
		icon: 'PersonAdd',
	},
	page404: {
		id: 'Page404',
		text: '404 Page',
		path: '/404',
		icon: 'ReportGmailerrorred',
	},
};

export const pageLayoutTypesPagesMenu = {
	layoutTypes: {
		id: 'layoutTypes',
		text: 'CS Management System',
	},
	profile: {
		id: 'updateProfile',
		text: 'Profile',
		path: '/profile/update',
		icon: 'Person',
		hide: true,
	},

	employee: {
		id: 'employees',
		text: 'Employees',
		path: 'employee',
		icon: 'People',
		hide: false,

		subMenu: {
			addEmployee: {
				id: 'addEmployee ',
				text: 'Add Employee [a-h]',
				path: '/employee/add',
				icon: 'Add',
				hide: false,
			},
			listEmployees: {
				id: 'listEmployees',
				text: 'List Employees [a-h]',
				path: '/employee/list',
				icon: 'FormatListNumbered',
				hide: false,
			},
			editEmployee: {
				id: 'editemployee',
				text: 'Edit Employee',
				path: '/employee/edit',
				hide: true,
			},
			employeeDetail: {
				id: 'employeeDetail',
				text: 'Employee Employee',
				path: '/employee/detail',
				hide: true,
			},
		},
	},

	leaves: {
		id: 'leaves',
		text: 'Leaves',
		path: 'leaves',
		icon: 'BeachAccess',
		hide: false,

		subMenu: {
			requestaddLeaves: {
				id: 'requestAddLeaves',
				text: 'Apply Leave [e-h]',
				path: '/leaves/requestAddLeaves',
				icon: 'Add',
				hide: false,
			},
			listRequestleaves: {
				id: 'listRequestleaves',
				text: 'Listing [a-h]',
				path: '/leaves/listRequestedLeaves',
				icon: 'FormatListNumbered',
				hide: false,
			},
			listleavesBalance: {
				id: 'listleavesBalance',
				text: 'Leave Balance [a-h]',
				path: '/leaves/detailLeave',
				icon: 'FormatListNumbered',
				hide: false,
			},
			employeeRequestedLeaves: {
				id: 'editLeaves',
				text: 'My Applied Leaves',
				path: '/leaves/my-leaves',
				icon: 'EditLocation',
				hide: true,
			},
			editleaves: {
				id: 'editLeaves',
				text: 'Edit Leaves',
				path: '/leaves/editleaves',
				icon: 'EditLocation',
				hide: true,
			},
		},
	},

	device: {
		id: 'deviceInfo',
		text: 'Device',
		path: 'device',
		icon: 'Devices',
		hide: false,

		subMenu: {
			addDevice: {
				id: 'deviceInfo',
				text: 'Device ',
				path: '/add/device',
				icon: 'Add',
				hide: false,
			},
			listDevice: {
				id: 'listDevice',
				text: 'List Device ',
				path: '/device/list',
				icon: 'FormatListNumbered',
				hide: false,
			},
			editDevice: {
				id: 'editDevice',
				text: 'Edit Device',
				path: '/device/edit',
				icon: 'Edit',
			},
			deleteDevice: {
				id: 'delete Device',
				text: 'Delete Device',
				path: '/device/delete',
				icon: 'Delete',
			},
			connectDevice: {
				id: 'connect Device',
				text: 'Connect Device',
				path: '/device/connect',
				icon: 'PowerSettingsNew',
			},
		},
	},

	holiday: {
		id: 'holiday',
		text: 'Holiday',
		path: 'holiday',
		icon: 'HolidayVillage',
		hide: false,

		subMenu: {
			addHoliday: {
				id: 'addHoliday',
				text: 'Add Holiday',
				path: '/holiday/add',
				icon: 'Add',
				hide: false,
			},
			listHoliday: {
				id: 'listHolidays',
				text: 'List Holiday',
				path: '/holiday/list',
				icon: 'FormatListNumbered',
				hide: false,
			},
			editHoliday: {
				id: 'edit Holiday',
				text: 'Edit Holiday',
				path: '/holiday/edit',
				icon: 'Edit',
			},
			deleteHoliday: {
				id: 'delete Holiday',
				text: 'Delete Holiday',
				path: '/holiday/delete',
				icon: 'Delete',
			},
		},
	},

	settings: {
		id: 'settings',
		text: 'Settings',
		path: 'config',
		icon: 'Settings',
		hide: false,

		subMenu: {
			addConfiguration: {
				id: 'addConfiguration',
				text: 'Add Configuration',
				path: '/config/add',
				icon: 'AdminPanelSettings',
			},
			listConfiguration: {
				id: 'listConfigurations',
				text: 'Configurations',
				path: '/config/list',
				icon: 'AdminPanelSettings',
				hide: false,
			},
			editConfiguration: {
				id: 'editConfiguration',
				text: 'Edit Configuration',
				path: '/config/edit',
				icon: 'Edit',
			},
			deleteConfiguration: {
				id: 'deleteConfiguration',
				text: 'Delete Configuration',
				path: '/config/delete',
				icon: 'Delete',
			},
		},
	},

	logs: {
		id: 'Logs',
		text: 'Logs',
		path: 'activity-logs',
		icon: 'History',
		hide: false,
		subMenu: {
			listActiviyLogs: {
				id: 'listActivityLogs',
				text: 'Activity Logs',
				path: '/activity-logs/list',
				icon: 'TrackChanges',
				hide: false,
			},
			listSystemLogs: {
				id: 'listSystemLogs',
				text: 'System Logs',
				path: '/system-logs/list',
				icon: 'Monitor',
				hide: false,
			},
		},
	},

	attendance: {
		id: 'attendane',
		text: 'Attendance',
		path: 'attendance',
		icon: 'EventNote',
		hide: false,

		subMenu: {
			markAttendance: {
				id: 'markAttendance',
				text: 'Mark Attendance',
				path: '/attendance/mark',
				icon: 'MarkChatRead',
				hide: false,
			},
			listAttendance: {
				id: 'listAttendances',
				text: 'List Attendance',
				path: '/attendance/list',
				icon: 'FormatListNumbered',
				hide: false,
			},
			attendanceDetail: {
				id: 'attendanceDetail',
				text: 'Attendance Detail',
				path: '/employee/attendance/detail',
				icon: 'Details',
				hide: true,
			},
		},
	},

	roles: {
		id: 'roles',
		text: 'Roles',
		path: 'roles',
		icon: 'AccountBox',
		hide: false,

		subMenu: {
			addRole: {
				id: 'role',
				text: 'Add Role',
				path: '/roles/add',
				icon: 'Add',
			},
			listRole: {
				id: 'permission',
				text: 'List Roles',
				path: '/roles/list',
				icon: 'List',
			},
			editRole: {
				id: 'editRole',
				text: 'Edit Role',
				path: '/roles/edit',
				icon: 'Edit',
			},
		},
	},
};